// Generated by BUCKLESCRIPT VERSION 1.9.1, PLEASE EDIT WITH CARE
'use strict';

var $$Array          = require("bs-platform/lib/js/array.js");
var React            = require("react");
var ReasonReact      = require("reason-react/lib/js/src/reasonReact.js");
var NotificationItem = require("./notificationItem");

var component = ReasonReact.statelessComponent("NotificationList");

function make(notifications, markAsRead, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      var match = notifications.length;
      if (match !== 0) {
        return React.createElement("main", {
                    className: "mw6 center"
                  }, $$Array.map((function (n) {
                          return ReasonReact.element(/* Some */[n[/* id */0]], /* None */0, NotificationItem.make(n, markAsRead, /* array */[]));
                        }), notifications));
      } else {
        return React.createElement("div", {
                    className: "mw6 center tc mv3"
                  }, React.createElement("h2", {
                        className: "f5 f4-m f3-l fw2 black-50 mt0 lh-copy"
                      }, "Nothing to see here."));
      }
    });
  return newrecord;
}

exports.component = component;
exports.make      = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/notificationList.re
// module id = 102
// module chunks = 0